'use strict';

const cellTextSubTokens = (theme) => ({
    cellTextSubSubColor: theme.palette.grey400,
    cellTextSubSubFontWeight: theme.typography.fontWeight.normal,
});

exports.cellTextSubTokens = cellTextSubTokens;
//# sourceMappingURL=cellTextSub.js.map
